var page_nb = 1
var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
})


function close_ul(the_id) {
  if ($("#"+the_id).next().css("display") == "block") {
    $("#"+the_id).next().css("display","none")
  } else {
  	$("#"+the_id).next().css("display","block")
  }
}


function resize_prod_heigth() {
   biggest_div  = 0
   
   $( ".results-prod-upper-layer" ).each(function() {
     if ($( this ).height() > biggest_div ) {
     	biggest_div = $( this ).height()
     }
   });
   
   $( ".results-prod-upper-layer" ).each(function() {
		$( this ).css("height",biggest_div)
   });
}


function resize_panel() {
  if ($(window).width() > 749) {
    product_main_panel = $(".result-main-panel").width()
    $(".resuts-product-div").css("width", product_main_panel -256 )
  }
}


$(window).resize(function() {
  resize_panel()
});


function roundHundred(value){
   return Math.round(value/100)*100
}


function request_prod() {

  list_requested = []
  brand = 'brand='
  price_range = 'price-range='
  
  $( ".check" ).each(function() {
    if ($( this ).is(':checked') && $(this).attr("data-attr") != 'brand' && $(this).attr("data-attr") != 'price-range' ){
      	list_requested.push($( this ).attr("id"))
    }
    else if ($( this ).is(':checked') && $(this).attr("data-attr") == 'brand' ) {
    	brand = brand+$( this ).attr("id")
    }
    else if ($( this ).is(':checked') && $(this).attr("data-attr") == 'price-range' ) {
    	price_range = price_range+$( this ).attr("id").replace("$",'').replace("$",'').replace(" ",'').replace(" ",'')
    }
    
  });
  

  var filters = list_requested.toString();

  order = $( "#order-setting" ).val()
  url = "https://buildmyserver.com/get-collection/get-prod.json?page="+page_nb+"&filters=" + filters + "&collection_handle=" + collection_handle +'&'+ brand +"&order=" + order + "&" + price_range
   
  
  
  height =  $(".result-sort-options").height()
  
    $(".resuts-product-div").empty()

    $(".resuts-product-div").append("<div class='loading-div' width='100%' style='height:"+height+"px'><img alt='Loading gif' id='gif-loader' src='https://cdn.shopify.com/s/files/1/0006/3029/2540/files/ajax-loader_1.gif?v=1602161027'> </div>")
  	$(".prod-pagination ul").empty();
    
   	 $.get( url, function( data ) {
 
     	$(".resuts-product-div").empty()
        arrange_elem(data)

     });
}



function page_nb_change() {
	
  $( ".prod-pagination li" ).each(function() { 
    if ($(this).attr("id") == page_nb ) $(this).css("background-color",'red')    
  })

}


function go_back() {
  if (page_nb > 1) {
	page_nb =  page_nb -1
    request_prod()
    page_nb_change()
  }
  
  
}

function go_next() {
	if (page_nb < nb_pages ) {
	page_nb =  page_nb +1
    request_prod()
    page_nb_change()
  }
 
}

function go_page(page) {
  if (page != page_nb ) {
	page_nb = page
    request_prod()
    page_nb_change()
  }
    
}

function filter_change() {
  	page_nb = 1
	request_prod()
    page_nb_change()
}


function arrange_elem(data) {

          product = JSON.parse(data['products'])
          
          if (data['prod_total'] == '0' ) {
          	
          		$(".resuts-product-div").append("<div class='sorry'><div class='no-match'>Sorry no product match your query</div><div class='need-help'>Need help?<p>Visit the <a href='/pages/frequently-asked-questions'>FAQ</a> or <a href='/pages/contact-us'>contact us</a></p></div></div>")
          }
  
  			$('#qty-showing').text(data['prod_total'])



          for (i=0;i < product.length; i++ ){
            
      
            product[i]['prod_description'] = product[i]['prod_description'].slice(45).split("Processors: ");
            product[i]['prod_description'] =  product[i]['prod_description'][product[i]['prod_description'].length - 1]
      	
            
            if (product[i]['prod_description'].length > 80){
            	product[i]['prod_description'] = product[i]['prod_description'].substring(0,80) + '...'
            }
            
            
            if (product[i]['prod_img1'] == "") {
              product[i]['prod_img1'] = "https://onlineimages.techmikeny.com/oimages/generic/ics.png"
            }
            if (product[i]['prod_img2'] == "" ) {
              
              if ( collection_handle.includes("configure") == false ){
            	 $(".resuts-product-div").append("<div  class='results-prod-upper-layer'> <div class='buy-me-now' id='buy-now-"+product[i]['prod_id']+"'></div> <a href='"+product[i]['prod_handleID'].replace('collections/','')+"'> </a><a href='"+product[i]['prod_handleID'].replace('collections/','')+"'><div class='result-prod-img-div'><img alt='Product Result Image' id='prod-img1-disable' src='"+product[i]['prod_img1']+"'><div class='results-prod-lower-layer'><div class='result-prod-lower'><div class='result-prod-description-div'><div class='result-title'><span>"+product[i]['prod_title']+"</span></div><div class='result-description'><span>"+product[i]['prod_description']+"</span></div>\<div class='result-price'>\<span>"+formatter.format(product[i]['prod_price'])+"</span></div></div></div></div></div></a></div>")
              }else {
              	$(".resuts-product-div").append("<div  class='results-prod-upper-layer'> </a><a href='"+product[i]['prod_handleID'].replace('collections/','')+"'><div class='result-prod-img-div'><img alt='Product Result Image' id='prod-img1-disable' src='"+product[i]['prod_img1']+"'><div class='results-prod-lower-layer'><div class='result-prod-lower'><div class='result-prod-description-div'><div class='result-title'><span>"+product[i]['prod_title']+"</span></div><div class='result-description'><span>"+product[i]['prod_description']+"</span></div>\<div class='result-price'>\<span>"+formatter.format(product[i]['prod_price'])+"</span></div></div></div></div></div></a></div>")
              }
              } 
            else {
              if ( collection_handle.includes("configure") == false ){
              
            	$(".resuts-product-div").append("<div  class='results-prod-upper-layer'> <div class='buy-me-now' id='buy-now-"+product[i]['prod_id']+"'></div> <a href='"+product[i]['prod_handleID'].replace('collections/','')+"'> </a><a href='"+product[i]['prod_handleID'].replace('collections/','')+"'><div class='result-prod-img-div'><img alt='Product Result Image' id='prod-img2' src='"+product[i]['prod_img2']+"'><img alt='Product Result Image' id='prod-img1' src='"+product[i]['prod_img1']+"'><div class='results-prod-lower-layer'><div class='result-prod-lower'><div class='result-prod-description-div'><div class='result-title'><span>"+product[i]['prod_title']+"</span></div>\<div class='result-description'><span>"+product[i]['prod_description']+"</span></div>\<div class='result-price'>\<span>"+formatter.format(product[i]['prod_price'])+"</span></div></div></div></div></div></a></div>")
              }
              else {
                $(".resuts-product-div").append("<div  class='results-prod-upper-layer'>  <a href='"+product[i]['prod_handleID'].replace('collections/','')+"'> </a><a href='"+product[i]['prod_handleID'].replace('collections/','')+"'><div class='result-prod-img-div'><img alt='Product Result Image' id='prod-img2' src='"+product[i]['prod_img2']+"'><img alt='Product Result Image' id='prod-img1' src='"+product[i]['prod_img1']+"'><div class='results-prod-lower-layer'><div class='result-prod-lower'><div class='result-prod-description-div'><div class='result-title'><span>"+product[i]['prod_title']+"</span></div>\<div class='result-description'><span>"+product[i]['prod_description']+"</span></div>\<div class='result-price'>\<span>"+formatter.format(product[i]['prod_price'])+"</span></div></div></div></div></div></a></div>")

              }
            }
          
          
          } 
			
  
  		
          nb_pages = Math.ceil(data['prod_total']/20)

          if ((nb_pages > 1)) {
            if (page_nb !=1){
            $(".prod-pagination ul").append("<li  onclick='go_back()'><span id='go-left-arrow'>&#8249;&#8249;</li>")
            }
              
              if (page_nb > 4) {
                   $(".prod-pagination ul").append("<li id='1' onclick='go_page(1)'><span  id='number'>1</li>")
                   $(".prod-pagination ul").append("<li ><span>...</li>")
              }
            
            	for (i=page_nb - 3;i < page_nb ;i++){
                  if (i > 0) {
                  if (page_nb == i ){
                      selection = "yes-current-page"
                  }
                  else {
                      selection = "not-current-page"
                  }
                  $(".prod-pagination ul").append("<li id='"+selection+"' onclick='go_page("+i+")'><span id='number'>"+i+"</li>")
                }
                }
         
            
                for (i=page_nb;i < page_nb +4;i++){
                  if(i < nb_pages) {
                  if (page_nb == i ){
                      selection = "yes-current-page"
                  }
                  else {
                      selection = "not-current-page"
                  }
                  $(".prod-pagination ul").append("<li id='"+selection+"' onclick='go_page("+i+")'><span id='number'>"+i+"</li>")
                  }
                }
            
            if (page_nb+1 !=nb_pages && page_nb != nb_pages) {
            	$(".prod-pagination ul").append("<li ><span>...</li>")
            }
            	 if (page_nb == nb_pages ){
                      selection = "yes-current-page"
                  }
                  else {
                      selection = "not-current-page"
                  }
                $(".prod-pagination ul").append("<li id='"+selection+"' onclick='go_page("+nb_pages+")'><span id='number'>"+nb_pages+"</li>")
                if (page_nb !=nb_pages){
           $(".prod-pagination ul").append("<li onclick='go_next()'><span id='go-right-arrow'>&#8250;&#8250;</li>")
                }
          }

  

  if ( collection_handle.includes("configure") == false ) {
  
    var checkExist = setInterval(function() {
    if ($('#the-canvas').length) {
      clearInterval(checkExist);
    }
  }, 100); 
  
  
  
   if (window.ShopifyBuy) {
    if (window.ShopifyBuy.UI) {
      ShopifyBuyInit();
    } else {
      loadScript();
    }
  } else {
    loadScript();
  }
  function loadScript() {
    var script = document.createElement('script');
    script.async = true;
    script.src = scriptURL;
    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
    script.onload = ShopifyBuyInit;
  }
  function ShopifyBuyInit() {
    var client = ShopifyBuy.buildClient({
      domain: 'techmikeny-dev.myshopify.com',
      storefrontAccessToken: '76db45e94cf60844b71d774baa672ffa',
    });
    ShopifyBuy.UI.onReady(client).then(function (ui) {
      
      for (i=0;i <  product.length;i++){
        
        elem_name = "buy-now-" + product[i]['prod_id']

      
      ui.createComponent('product', {
        id: product[i]['prod_id'],
        node: document.getElementById(elem_name),
        moneyFormat: '%24%7B%7Bamount%7D%7D',
        options: {
  "product": {
    "styles": {
      "product": {
        "@media (min-width: 601px)": {
          "max-width": "calc(25% - 20px)",
          "margin-left": "20px",
          "margin-bottom": "50px"
        }
      },
	  
   
      "button": {
      
        ":hover": {
          "background-color": "#1889c7"
        },
        "background-color": "#1b98dd",
        ":focus": {
          "background-color": "#1889c7"
        }
      }
    },
    "buttonDestination": "checkout",
    "contents": {
      "img": false,
      "button": false,
      "buttonWithQuantity": true,
      "title": false,
      "price": false
    },
    "text": {
      "button": "Buy Me Now!"
    }
  },
  "productSet": {
    "styles": {
      "products": {
        "@media (min-width: 601px)": {
          "margin-left": "-20px"
        }
      }
    }
  },
  "modalProduct": {
    "contents": {
      "img": false,
      "imgWithCarousel": true,
      "button": false,
      "buttonWithQuantity": true
    },
    "styles": {
      "product": {
        "@media (min-width: 601px)": {
          "max-width": "100%",
          "margin-left": "0px",
          "margin-bottom": "0px"
        }
      },
      "button": {
        ":hover": {
          "background-color": "#1889c7"
        },
        "background-color": "#1b98dd",
        ":focus": {
          "background-color": "#1889c7"
        }
      }
    },
    "text": {
      "button": "Add to cart"
    }
  },
  "cart": {
    "styles": {
      "button": {
        ":hover": {
          "background-color": "#1889c7"
        },
        "background-color": "#1b98dd",
        ":focus": {
          "background-color": "#1889c7"
        }
      }
    },
    "text": {
      "total": "Subtotal",
      "button": "Checkout"
    }
  },
  "toggle": {
    "styles": {
      "toggle": {
        "background-color": "#1b98dd",
        ":hover": {
          "background-color": "#1889c7"
        },
        ":focus": {
          "background-color": "#1889c7"
        }
      }
    }
  }
},
      });
      
      }
      
    });
  }
  
    
  }
  
  
  
}

function imgNotFound(obj){
  obj.src = "https://onlineimages.techmikeny.com/oimages/generic/ics.png";
}